<div class="row align-items-center mt-3">
    <div class="col-md-2">
        <strong>{{ 'envelope.observer.observers' | translate | titlecase }}</strong>
    </div>
    <div class="col-md-4 my-3 ml-auto-mobile d-flex justify-content-end">
        <cdx-toolbar-search (onTyping)="onSearch($event)" [value]="valueSearch"
            [placeholder]="'search' | translate | titlecase" [maxlength]="255" [debounceTime]="600">
        </cdx-toolbar-search>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="table-responsive table__container">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col" class="text-left">
                            {{ "name" | translate | titlecase }}
                        </th>
                        <th scope="col" class="text-left">
                            {{ "mail" | translate | titlecase }}
                        </th>
                        <th scope="col" class="text-left">
                            {{ "envelope.observer.whenNotified" | translate | titlecase }}
                        </th>
                        <th scope="col" class="text-left">
                            {{ "envelope.observer.titleSendCompletedEnvelope" | translate | titlecase }}
                        </th>
                        <th *ngIf="isSendWhatsapp || isSignFreemium" scope="col" class="text-left">
                            {{ 'telephone' | translate | titlecase }}
                        </th>
                        <th *ngIf="(!canSendWhatsApp || isSendWhatsapp) || isSignFreemium" scope="col" class="text-left">
                            {{ 'envelope.observer.sendingByWhatsapp' | translate | translate }}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngIf="filteredObservers.length > 0; else blankSlateSearchTemplate">
                        <tr *ngFor="let observer of filteredObservers; index as i">
                            <td class="text-truncate text-left">
                                {{ observer.name }}
                            </td>
                            <td class="text-truncate text-left">
                                {{ observer.mail | mailObfuscate }}
                            </td>
                            <td class="text-truncate text-left">
                                {{ observer.whenWillNotified === 1 ? ("envelope.observer.sendEachSignature" | translate) : "envelope.observer.sendCompletedEnvelope" | translate }}
                            </td>
                            <td class="text-truncate text-left">
                                {{ observer.sendCopyFinishedEnvelope ? ("envelope.observer.reviewSendCopy.sendCompletedEnvelope" | translate) : "envelope.observer.reviewSendCopy.doNotSendCompletedEnvelope" | translate }}
                            </td>
                            <td *ngIf="isSendWhatsapp || isSignFreemium" class=" text-truncate"
                                style="text-align: left;">{{(observer.phoneNumber || observer.obfuscatePhoneNumber) | phoneObfuscate}}</td>
                            <td *ngIf="(!canSendWhatsApp || isSendWhatsapp) && !isSignFreemium" align="center">
                                <div class="icon-switch-container">
                                <fa-icon *ngIf="!canSendWhatsApp && !isSignFreemium" class="fa-fw" [icon]="['fas','crown']"></fa-icon>
                                <cdx-toggle-switch 
                                    class="pointerMouse" 
                                    [disabled]="observer.acceptWhatsApp === false || !(observer.phoneNumber || observer.obfuscatePhoneNumber) || !canSendWhatsApp ? true : false"
                                    [toggledOn]="observer.sendWhatsApp"
                                    (toggle)="needSendWhatsapp($event, observer.id)"
                                    (click)="handleToggleClick($event)">
                                </cdx-toggle-switch>
                                </div>
                            </td>
                            <td *ngIf="isSignFreemium" align="center">
                                <div class="d-flex justify-content-left">
                                    <fa-icon class="fa-fw" [icon]="['fas','crown']"></fa-icon>
                                    <div (click)="toastWhatsFree()" class="pointerMouse ml-2">
                                        <cdx-toggle-switch [disabled]="true"></cdx-toggle-switch>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #blankSlateSearchTemplate>
    <ng-container>
        <td colspan="8" style="width: 100%;">
            <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateClearSearchClick()">
                {{'envelope.observer.blankSlateSearchText' | translate}}</cdx-blankslate>
        </td>
    </ng-container>
</ng-template>
